import { FeatureFlag } from "@/types/auth/FeatureFlags";
import type { IOrgCommand } from "../Types/CommandPaletteTypes";

// Hand-maintained. Keep in sync with the real routes and sidebar gating
// (src/components/layout/navigation/sidebar.tsx). Hide* flags are inverse
// (visible when off); RedeemablesV2 is positive (visible when on).
export const ORG_COMMANDS: Array<IOrgCommand> = [
  // Navigation
  {
    id: "accounts",
    label: "Linked Accounts",
    group: "Navigation",
    path: "/accounts",
    featureFlag: FeatureFlag.HideLinkedAccounts,
    flagInverse: true,
  },
  {
    id: "inventory",
    label: "Global Menus",
    keywords: ["menu", "menus"],
    group: "Navigation",
    path: "/inventory",
    featureFlag: FeatureFlag.HideGlobalMenus,
    flagInverse: true,
  },
  {
    id: "past-orders",
    label: "Past Orders",
    group: "Navigation",
    path: "/past-orders",
    featureFlag: FeatureFlag.HidePastOrders,
    flagInverse: true,
  },
  {
    id: "past-transactions",
    label: "Past Transactions",
    group: "Navigation",
    path: "/past-transactions",
  },
  {
    id: "reports",
    label: "Reports",
    group: "Navigation",
    path: "/reports",
    featureFlag: FeatureFlag.HideReports,
    flagInverse: true,
  },
  {
    id: "reports-maintenance",
    label: "Reports Maintenance",
    group: "Navigation",
    path: "/reports/maintenance",
    featureFlag: FeatureFlag.ReportingMaintenance,
  },
  {
    id: "devices",
    label: "Devices",
    group: "Navigation",
    path: "/devices",
    featureFlag: FeatureFlag.HideDevices,
    flagInverse: true,
  },
  {
    id: "settings",
    label: "Settings",
    group: "Navigation",
    path: "/settings",
    featureFlag: FeatureFlag.HideSettings,
    flagInverse: true,
  },
  {
    id: "settings-third-party",
    label: "Third-party Accounts",
    keywords: ["integrations"],
    group: "Navigation",
    path: "/settings/accounts/third-party",
    featureFlag: FeatureFlag.HideSettings,
    flagInverse: true,
  },

  // Global Menus (all gated by HideGlobalMenus, inverse)
  {
    id: "inventory-categories",
    label: "Categories",
    group: "Global Menus",
    path: "/inventory/categories",
    featureFlag: FeatureFlag.HideGlobalMenus,
    flagInverse: true,
  },
  {
    id: "inventory-items",
    label: "Items",
    group: "Global Menus",
    path: "/inventory/items",
    featureFlag: FeatureFlag.HideGlobalMenus,
    flagInverse: true,
  },
  {
    id: "inventory-modifier-sets",
    label: "Modifier Sets",
    group: "Global Menus",
    path: "/inventory/modifier-sets",
    featureFlag: FeatureFlag.HideGlobalMenus,
    flagInverse: true,
  },
  {
    id: "inventory-modifiers",
    label: "Modifiers",
    group: "Global Menus",
    path: "/inventory/modifiers",
    featureFlag: FeatureFlag.HideGlobalMenus,
    flagInverse: true,
  },
  {
    id: "inventory-global-menus",
    label: "Global Menus List",
    group: "Global Menus",
    path: "/inventory/global-menus",
    featureFlag: FeatureFlag.HideGlobalMenus,
    flagInverse: true,
  },
  {
    id: "inventory-items-new",
    label: "New Item",
    keywords: ["create", "add"],
    group: "Global Menus",
    path: "/inventory/items/new",
    featureFlag: FeatureFlag.HideGlobalMenus,
    flagInverse: true,
  },
  {
    id: "inventory-categories-new",
    label: "New Category",
    keywords: ["create", "add"],
    group: "Global Menus",
    path: "/inventory/categories/new",
    featureFlag: FeatureFlag.HideGlobalMenus,
    flagInverse: true,
  },
  {
    id: "inventory-modifier-sets-new",
    label: "New Modifier Set",
    keywords: ["create", "add"],
    group: "Global Menus",
    path: "/inventory/modifier-sets/new",
    featureFlag: FeatureFlag.HideGlobalMenus,
    flagInverse: true,
  },
  {
    id: "inventory-modifiers-new",
    label: "New Modifier",
    keywords: ["create", "add"],
    group: "Global Menus",
    path: "/inventory/modifiers/new",
    featureFlag: FeatureFlag.HideGlobalMenus,
    flagInverse: true,
  },

  // Redeemables (all gated by RedeemablesV2, positive)
  {
    id: "redeemables-code-lookup",
    label: "Code Lookup",
    keywords: ["voucher", "redeemable"],
    group: "Redeemables",
    path: "/redeemables/code-lookup",
    featureFlag: FeatureFlag.RedeemablesV2,
  },
  {
    id: "redeemables-enhanced",
    label: "Redeemable Configurations",
    group: "Redeemables",
    path: "/redeemables/enhanced",
    featureFlag: FeatureFlag.RedeemablesV2,
  },
  {
    id: "redeemables-packages",
    label: "Item Packages",
    group: "Redeemables",
    path: "/redeemables/packages",
    featureFlag: FeatureFlag.RedeemablesV2,
  },
  {
    id: "redeemables-standard",
    label: "Redeemables",
    group: "Redeemables",
    path: "/redeemables/standard",
    featureFlag: FeatureFlag.RedeemablesV2,
  },

  // System
  {
    id: "support",
    label: "Support",
    keywords: ["help", "chat"],
    group: "System",
    path: "https://dines.co.uk/chat",
    external: true,
  },
];

export const GROUP_ORDER: Array<string> = [
  "Navigation",
  "Global Menus",
  "Redeemables",
  "System",
];
